import React, { useEffect, useState, memo } from 'react';
import { useSearchParams } from 'react-router-dom';
export const PortfolioPage = () => {
  useEffect(() => {
    document.title = 'Companies | Race Capital';
  }, []);
  const [searchParams] = useSearchParams();
  const categoryFromUrl = searchParams.get('category');
  const categoryDisplayNames = {
    Featured: 'Featured',
    'AI and Data Infrastructure': 'AI/Data',
    'Compute Infrastructure': 'Compute',
    Security: 'Security',
    'Devtools, Productivity & Open-source': 'Devtools/Productivity',
    'Decentralized Networks & Financial Infrastructure': 'Decentralized'
  };
  const categories = ['Featured', 'AI and Data Infrastructure', 'Compute Infrastructure', 'Security', 'Devtools, Productivity & Open-source', 'Decentralized Networks & Financial Infrastructure'];
  const [activeCategory, setActiveCategory] = useState('Featured');
  // Set active category from URL parameter on mount
  useEffect(() => {
    if (categoryFromUrl && categories.includes(categoryFromUrl)) {
      setActiveCategory(categoryFromUrl);
    }
  }, [categoryFromUrl]);
  const featuredOrder = {
    Databricks: 1,
    'Play AI': 2,
    'Groq (Acq by Nvidia)': 3,
    Goodnotes: 4,
    Vectara: 5,
    'Clerk Chat': 6
  };
  const aiDataOrder = {
    Databricks: 1,
    Vectara: 2,
    'Play AI (Acq by Meta Superintelligence Lab)': 3,
    'Opaque Systems': 4,
    Chakra: 5,
    Linewise: 6,
    Openlayer: 7,
    'Pair Systems': 8,
    S2: 9,
    Okareo: 10,
    VMax: 11,
    'Moody Pines': 12,
    Vectroid: 13,
    'Airtrain (Acq by Weights and Biases)': 14,
    Unify: 15,
    Antigma: 16,
    Datahive: 17
  };
  const computeOrder = {
    'Groq (Acq by Nvidia)': 1,
    'Architect Labs': 2,
    Skypilot: 3
  };
  const devtoolsOrder = {
    Goodnotes: 1,
    'Clerk Chat': 2,
    Yarn: 3,
    'HyperDX (Acq by Clickhouse)': 4,
    GTMEngine: 5,
    Scarf: 6,
    Workduo: 7,
    Notifi: 8,
    Concierge: 9,
    Thruline: 10
  };
  const decentralizedOrder = {
    Solana: 1,
    'Lightning Labs': 2,
    Inversion: 3,
    Irys: 4,
    Shinami: 5,
    Huma: 6,
    Save: 7,
    Termina: 8,
    Citcon: 9,
    Solayer: 10,
    Bullet: 11
  };
  const companies = [{
    name: 'AirMDR',
    logo: 'https://res.cloudinary.com/dtycj98cm/image/upload/v1754429419/AirMDR_White_Large_bnnbhg.png',
    description: 'AI Managed Detection and Response Platform',
    category: 'Security',
    website: 'https://airmdr.com'
  }, {
    name: 'Airtrain (Acq by Weights and Biases)',
    logo: 'https://res.cloudinary.com/dtycj98cm/image/upload/v1761250603/Airtrain_White_ztfano.png',
    description: 'No-code compute platform for LLM evaluation and fine-tuning',
    category: 'AI and Data Infrastructure',
    website: 'https://www.airtrain.ai/'
  }, {
    name: 'Anecdote',
    logo: 'https://res.cloudinary.com/dtycj98cm/image/upload/v1761266822/Anecdote_White_zmxvdy.png',
    description: 'AI Customer Service platform',
    category: 'Devtools, Productivity & Open-source',
    website: 'https://www.anecdoteai.com'
  }, {
    name: 'Antigma',
    logo: 'https://res.cloudinary.com/dtycj98cm/image/upload/v1761266807/Antigma_White_alnv7j.png',
    description: 'Verifiable Terminal Coding Agents',
    category: 'AI and Data Infrastructure',
    website: 'https://antigma.ai'
  }, {
    name: 'Goodnotes',
    logo: 'https://res.cloudinary.com/dtycj98cm/image/upload/v1754432034/Goodnotes_White_Logo_ov9hvp.png',
    description: 'AI productivity tool',
    category: 'Devtools, Productivity & Open-source',
    featured: true,
    website: 'https://www.goodnotes.com'
  }, {
    name: 'Bullet',
    logo: 'https://res.cloudinary.com/dtycj98cm/image/upload/v1763936640/bullet_white_zzownh.png',
    description: 'SVM L1 DEX with on-chain order books',
    category: 'Decentralized Networks & Financial Infrastructure',
    website: 'https://www.bullet.xyz'
  }, {
    name: 'Chakra',
    logo: 'https://res.cloudinary.com/dtycj98cm/image/upload/v1761266796/Chakra_White_s5awrq.png',
    description: 'Open Data Protocol for AI',
    category: 'AI and Data Infrastructure',
    website: 'https://www.chakra.dev'
  }, {
    name: 'Linewise',
    logo: 'https://res.cloudinary.com/dtycj98cm/image/upload/v1791308827/Linewise_White_dvvjdf.png',
    description: 'Industrial Data Layer for Physical AI',
    category: 'AI and Data Infrastructure',
    website: 'https://www.linewise.io'
  }, {
    name: 'VMax',
    logo: 'https://res.cloudinary.com/dtycj98cm/image/upload/v1771801351/VMax_aavnhc.png',
    description: 'RL research lab focused on automated environment generation',
    category: 'AI and Data Infrastructure',
    website: 'https://vmax.ai'
  }, {
    name: 'Citcon',
    logo: 'https://res.cloudinary.com/dtycj98cm/image/upload/v1754432033/Citcon_White_Logo_e3bp0l.png',
    description: 'Digital Wallet Payment Platform',
    category: 'Decentralized Networks & Financial Infrastructure',
    website: 'https://citcon.com'
  }, {
    name: 'Clerk Chat',
    logo: 'https://res.cloudinary.com/dtycj98cm/image/upload/v1754425497/Clerk_White_Large_hs6hcs.png',
    description: 'AI Conversational messaging platform',
    category: 'Devtools, Productivity & Open-source',
    featured: true,
    website: 'https://clerk.chat/'
  }, {
    name: 'Concierge',
    logo: 'https://res.cloudinary.com/dtycj98cm/image/upload/v1754429402/Concierge_White_Large_qpxtrx.png',
    description: 'Connected AI assistant',
    category: 'Devtools, Productivity & Open-source',
    website: 'https://askconcierge.ai/'
  }, {
    name: 'Databricks',
    logo: 'https://res.cloudinary.com/dtycj98cm/image/upload/v1754428735/Databricks_White_Large_cmbvsn.png',
    description: 'AI data analytics lakehouse',
    category: 'AI and Data Infrastructure',
    featured: true,
    website: 'https://databricks.com'
  }, {
    name: 'Datahive',
    logo: 'https://res.cloudinary.com/dtycj98cm/image/upload/v1761266819/Datahive_White_qppgde.png',
    description: 'Data Curation platform',
    category: 'AI and Data Infrastructure',
    website: 'https://datahive.ai'
  }, {
    name: 'Groq (Acq by Nvidia)',
    logo: 'https://res.cloudinary.com/dtycj98cm/image/upload/v1771800604/Groq_Nvidia_arpeuo.png',
    description: 'AI Inference Chip',
    category: 'Compute Infrastructure',
    featured: true,
    website: 'https://groq.com/'
  }, {
    name: 'Architect Labs',
    logo: 'https://cdn.magicpatterns.com/uploads/bgXRnGXZtst3W5MxJ3Ryw8/Architect_Logo.png',
    description: 'Frontier AI Lab for Custom ASICs',
    category: 'Compute Infrastructure',
    website: 'https://architectlabs.com'
  }, {
    name: 'GTMEngine',
    logo: 'https://res.cloudinary.com/dtycj98cm/image/upload/v1761255316/GTMEngine_White_ixhpvz.png',
    description: 'GTM Pipeline Execution Platform',
    category: 'Devtools, Productivity & Open-source',
    website: 'https://www.gtmengine.ai'
  }, {
    name: 'Huma',
    logo: 'https://res.cloudinary.com/dtycj98cm/image/upload/v1754432034/Huma_White_Logo_deoge5.png',
    description: 'RWA lending platform',
    category: 'Decentralized Networks & Financial Infrastructure',
    website: 'https://huma.finance'
  }, {
    name: 'HyperDX (Acq by Clickhouse)',
    logo: 'https://res.cloudinary.com/dtycj98cm/image/upload/v1761250596/HyperDX_White_en1wz2.png',
    description: 'Unified Observability Platform',
    category: 'Devtools, Productivity & Open-source',
    website: 'https://www.hyperdx.io/'
  }, {
    name: 'Inversion',
    logo: 'https://res.cloudinary.com/dtycj98cm/image/upload/v1761266770/Inversion_White_rngh3h.png',
    description: 'L1 focused on on-chain GDP',
    category: 'Decentralized Networks & Financial Infrastructure',
    website: 'https://www.inversioncap.com'
  }, {
    name: 'Irys',
    logo: 'https://res.cloudinary.com/dtycj98cm/image/upload/v1763936643/Irys_White_fhlq68.png',
    description: 'Data provenance layer',
    category: 'Decentralized Networks & Financial Infrastructure',
    website: 'https://irys.xyz'
  }, {
    name: 'Lightning Labs',
    logo: 'https://res.cloudinary.com/dtycj98cm/image/upload/v1761266774/Lightning_Labs_Whitee_d2ruxl.png',
    description: 'Scaling and payments infrastructure',
    category: 'Decentralized Networks & Financial Infrastructure',
    website: 'https://lightning.engineering'
  }, {
    name: 'Maestro',
    logo: 'https://res.cloudinary.com/dtycj98cm/image/upload/v1761266803/Maestro_White_hrxp0b.png',
    description: 'AI Engineering intelligence platform',
    category: 'Devtools, Productivity & Open-source',
    website: 'https://getmaestro.ai'
  }, {
    name: 'Solana',
    logo: 'https://res.cloudinary.com/dtycj98cm/image/upload/v1761266778/Solana_White_csmhem.png',
    description: 'High performance L1',
    category: 'Decentralized Networks & Financial Infrastructure',
    website: 'https://solana.com'
  }, {
    name: 'Solayer',
    logo: 'https://res.cloudinary.com/dtycj98cm/image/upload/v1761266767/Solayer_White_r8inpb.png',
    description: 'Hardware-accelerated SVM L1',
    category: 'Decentralized Networks & Financial Infrastructure',
    website: 'https://solayer.org'
  }, {
    name: 'Notifi',
    logo: 'https://res.cloudinary.com/dtycj98cm/image/upload/v1754426204/Notifi_White_Logo_tzwrto.png',
    description: 'Notifications and messaging infrastructure',
    category: 'Devtools, Productivity & Open-source',
    website: 'https://notifi.network'
  }, {
    name: 'Okareo',
    logo: 'https://res.cloudinary.com/dtycj98cm/image/upload/v1754425600/Okareo_White_Large_hxbglf.png',
    description: 'LLM Evaluation and Fine-Tuning',
    category: 'AI and Data Infrastructure',
    website: 'https://okareo.com/'
  }, {
    name: 'Moody Pines',
    logo: 'https://res.cloudinary.com/dtycj98cm/image/upload/v1771801340/Moodypines_xyoeu7.png',
    description: 'Voice AI Agency',
    category: 'AI and Data Infrastructure',
    website: 'https://moodypines.ai',
    hidden: true
  }, {
    name: 'Opaque Systems',
    logo: 'https://res.cloudinary.com/dtycj98cm/image/upload/v1754428735/opaque_white_large_nos7uc.png',
    description: 'Confidential AI and Analytics Platform',
    category: 'AI and Data Infrastructure',
    website: 'https://opaque.co'
  }, {
    name: 'Openlayer',
    logo: 'https://res.cloudinary.com/dtycj98cm/image/upload/v1761250969/Openlayer_White_xopjrr.png',
    description: 'Gen AI Evaluation and Monitoring',
    category: 'AI and Data Infrastructure',
    website: 'https://www.openlayer.com/'
  }, {
    name: 'Opsin',
    logo: 'https://res.cloudinary.com/dtycj98cm/image/upload/v1761250581/Opsin_White_mxlhcv.png',
    description: 'Generative AI Security orchestration layer',
    category: 'Security',
    website: 'https://www.opsinsecurity.com/'
  }, {
    name: 'Aesopic',
    logo: 'https://res.cloudinary.com/dtycj98cm/image/upload/v1771800601/Aesopic_ldycfl.png',
    description: 'AI SaaS Security Posture Management (SSPM)',
    category: 'Security',
    website: 'https://aesopic.ai',
    hidden: true
  }, {
    name: 'Pair Systems',
    logo: 'https://res.cloudinary.com/dtycj98cm/image/upload/v1761250589/Pair_White_qgnp9x.png',
    description: 'Advanced memory and retrieval system for AI',
    category: 'AI and Data Infrastructure',
    website: 'https://www.pairsys.ai'
  }, {
    name: 'Play AI (Acq by Meta Superintelligence Lab)',
    logo: 'https://res.cloudinary.com/dtycj98cm/image/upload/v1761266826/Play_Meta_White_qt8smr.png',
    description: 'Generative Voice Platform',
    category: 'AI and Data Infrastructure',
    featured: true,
    website: 'https://play.ai'
  }, {
    name: 'S2',
    logo: 'https://res.cloudinary.com/dtycj98cm/image/upload/v1761266785/S2_White_tprslj.png',
    description: 'Serverless real-time, streaming datastore',
    category: 'AI and Data Infrastructure',
    website: 'https://s2.dev'
  }, {
    name: 'Scarf',
    logo: 'https://res.cloudinary.com/dtycj98cm/image/upload/v1761250595/Scarf_White_yrscmg.png',
    description: 'Analytics on Open Source Usage',
    category: 'Devtools, Productivity & Open-source',
    website: 'https://about.scarf.sh'
  }, {
    name: 'Shinami',
    logo: 'https://res.cloudinary.com/dtycj98cm/image/upload/v1761266792/Shinami_White_mggzai.png',
    description: 'Move Development platform for Aptos and Sui',
    category: 'Decentralized Networks & Financial Infrastructure',
    website: 'https://www.shinami.com'
  }, {
    name: 'Skypilot',
    logo: 'https://res.cloudinary.com/dtycj98cm/image/upload/v1754429401/Skypilot_White_Large_dimtjc.png',
    description: 'OS for AI workloads',
    category: 'Compute Infrastructure',
    website: 'https://docs.skypilot.co/'
  }, {
    name: 'Save',
    logo: 'https://res.cloudinary.com/dtycj98cm/image/upload/v1761266789/Save_White_n1xftz.png',
    description: 'Lending and Borrowing Infra on Solana',
    category: 'Decentralized Networks & Financial Infrastructure',
    website: 'https://solend.fi'
  }, {
    name: 'Syntracts',
    logo: 'https://res.cloudinary.com/dtycj98cm/image/upload/v1761266800/Syntracts_White_ejgmqx.png',
    description: 'AI contract intelligence platform',
    category: 'Devtools, Productivity & Open-source',
    website: 'https://www.syntracts.com'
  }, {
    name: 'Termina',
    logo: 'https://res.cloudinary.com/dtycj98cm/image/upload/v1761266763/Termina_White_rgaafe.png',
    description: 'SVM Cloud platform',
    category: 'Decentralized Networks & Financial Infrastructure',
    website: 'https://www.termina.technology'
  }, {
    name: 'Thruline',
    logo: 'https://res.cloudinary.com/dtycj98cm/image/upload/v1754426203/Thruline_White_Logo_hm5inr.png',
    description: 'Future-Ready ERP System',
    category: 'Devtools, Productivity & Open-source',
    website: 'https://www.thruline.co/'
  }, {
    name: 'Unbound Security',
    logo: 'https://res.cloudinary.com/dtycj98cm/image/upload/v1754429389/Unbound_White_Large_d8k6sd.png',
    description: 'AI Security Gateway',
    category: 'Security',
    website: 'https://www.getunbound.ai'
  }, {
    name: 'Unify',
    logo: 'https://res.cloudinary.com/dtycj98cm/image/upload/v1761250581/Unify_White_vhd1tl.png',
    description: 'LLM Dynamic Router',
    category: 'AI and Data Infrastructure',
    website: 'https://unify.ai/'
  }, {
    name: 'Vectara',
    logo: 'https://res.cloudinary.com/dtycj98cm/image/upload/v1754936326/Vectara_White_Large_st1oba.png',
    description: 'Enterprise Gen AI platform',
    category: 'AI and Data Infrastructure',
    featured: true,
    website: 'https://vectara.com/'
  }, {
    name: 'Vectroid',
    logo: 'https://res.cloudinary.com/dtycj98cm/image/upload/v1761250589/Vectroid_White_wucli4.png',
    description: 'Vector DB for billions of vectors',
    category: 'AI and Data Infrastructure',
    website: 'https://www.vectroid.com/'
  }, {
    name: 'Workduo',
    logo: 'https://res.cloudinary.com/dtycj98cm/image/upload/v1761266815/Workduo_White_jpj5xz.png',
    description: 'Generative Engine Optimization Platform',
    category: 'Devtools, Productivity & Open-source',
    website: 'https://www.workduo.ai'
  }, {
    name: 'Yarn',
    logo: 'https://res.cloudinary.com/dtycj98cm/image/upload/v1761266811/Yarn_White_hw9n8c.png',
    description: 'AI Video platform for Sales & Marketing',
    category: 'Devtools, Productivity & Open-source',
    website: 'https://www.yarn.so'
  }];
  const filteredCompanies = activeCategory === 'Featured' ? companies.filter(company => company.featured && !company.hidden).sort((a, b) => {
    return (featuredOrder[a.name] || 999) - (featuredOrder[b.name] || 999);
  }) : activeCategory === 'AI and Data Infrastructure' ? companies.filter(company => company.category === activeCategory && !company.hidden).sort((a, b) => {
    return (aiDataOrder[a.name] || 999) - (aiDataOrder[b.name] || 999);
  }) : activeCategory === 'Compute Infrastructure' ? companies.filter(company => company.category === activeCategory && !company.hidden).sort((a, b) => {
    return (computeOrder[a.name] || 999) - (computeOrder[b.name] || 999);
  }) : activeCategory === 'Devtools, Productivity & Open-source' ? companies.filter(company => company.category === activeCategory && !company.hidden).sort((a, b) => {
    return (devtoolsOrder[a.name] || 999) - (devtoolsOrder[b.name] || 999);
  }) : activeCategory === 'Decentralized Networks & Financial Infrastructure' ? companies.filter(company => company.category === activeCategory && !company.hidden).sort((a, b) => {
    return (decentralizedOrder[a.name] || 999) - (decentralizedOrder[b.name] || 999);
  }) : companies.filter(company => company.category === activeCategory && !company.hidden);
  return <div className="w-full bg-white mt-20" data-id="element-418" data-mp="1nmgm7i5htmqy">
      <section className="w-full pt-20 pb-20 px-6 md:px-12 bg-white" data-id="element-419" data-mp="1nleyoe7aj7sc">
        <div className="max-w-7xl mx-auto" data-id="element-420" data-mp="1io598yjwiw4i">
          <div className="relative mb-6 overflow-visible" data-id="element-421" data-mp="1xdb7okax0ibc">
            <style jsx data-id="element-422" data-mp="1xcroz1dfxpw9">{`
              @keyframes fillFromLeft {
                from {
                  transform: scaleX(0);
                  transform-origin: left;
                }
                to {
                  transform: scaleX(1);
                  transform-origin: left;
                }
              }
              .racing-stripe {
                transform: scaleX(0);
                transform-origin: left;
                animation: fillFromLeft 0.8s ease-out forwards;
              }
              .racing-stripe:nth-child(1) {
                animation-delay: 0.1s;
              }
              .racing-stripe:nth-child(2) {
                animation-delay: 0.2s;
              }
              .racing-stripe:nth-child(3) {
                animation-delay: 0.3s;
              }
              .racing-stripe:nth-child(4) {
                animation-delay: 0.4s;
              }
            `}</style>
            <div className="absolute right-[12px] top-0 hidden md:flex flex-col space-y-2 pointer-events-none" data-id="element-423" data-mp="1scajor49jheb">
              <div className="racing-stripe h-1.5 bg-gradient-to-r from-red-600/30 to-red-600/10" style={{
              width: '240px',
              marginLeft: '0px'
            }} data-id="element-424" data-mp="1xau8r0e5l9aw"></div>
              <div className="racing-stripe h-1.5 bg-gradient-to-r from-red-600/35 to-red-600/15" style={{
              width: '200px',
              marginLeft: '40px'
            }} data-id="element-425" data-mp="1o9w20acbynom"></div>
              <div className="racing-stripe h-1.5 bg-gradient-to-r from-red-600/40 to-red-600/20" style={{
              width: '160px',
              marginLeft: '80px'
            }} data-id="element-426" data-mp="1dhnicalpsnww"></div>
              <div className="racing-stripe h-1.5 bg-gradient-to-r from-red-600/45 to-red-600/25" style={{
              width: '120px',
              marginLeft: '120px'
            }} data-id="element-427" data-mp="266kzubi3qgol"></div>
            </div>
            <h1 className="relative z-10 text-[clamp(2.5rem,5vw,4rem)] font-semibold text-[#070707] tracking-tight leading-[1.15]" data-id="element-428" data-mp="21e1gexwqgrbv">
              Our Portfolio
            </h1>
          </div>
          <p className="text-lg text-gray-600 max-w-3xl mb-16 leading-relaxed font-light" data-id="element-429" data-mp="2twfe8xi2kday">
            Race Capital partners with exceptional entrepreneurs building
            market-transforming companies in enterprise, infrastructure, AI, and
            more.
          </p>
          <div className="mb-16 overflow-x-auto" data-id="element-430" data-mp="3d0ijtfex1brz">
            <div className="flex space-x-3 pb-2" data-id="element-431" data-mp="3cz7fnehk620c">
              {categories.map(category => <button key={category} className={`px-5 py-2.5 rounded-lg whitespace-nowrap font-medium text-sm transition-all ${activeCategory === category ? 'bg-red-600 text-white' : 'bg-white text-gray-700 hover:bg-gray-50 border border-gray-200'}`} onClick={() => setActiveCategory(category)} data-id="element-432" data-mp="381o2khwljv9z">
                  {categoryDisplayNames[category]}
                </button>)}
            </div>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-433" data-mp="9hpa5dp9d733">
            {filteredCompanies.map((company, index) => <a key={index} href={company.website} target="_blank" rel="noopener noreferrer" className="group bg-white rounded-xl overflow-hidden hover:shadow-xl transition-all duration-300 border border-gray-100" data-id="element-434" data-mp="ckvbsb5uj018" data-mpi={index}>
                <div className="p-10 h-[200px] flex items-center justify-center bg-white" data-id="element-435" data-mp="ql66jpaa0yro">
                  <img src={company.logo} alt={`${company.name} logo`} className="max-h-[80px] max-w-full object-contain opacity-90 group-hover:opacity-100 transition-all duration-300" data-id="element-436" data-mp="3p2jx44hbh70t" />
                </div>
                <div className="p-8 border-t border-gray-100" data-id="element-437" data-mp="7ls7wu1lqzuu">
                  <h3 className="text-lg font-semibold text-[#070707] mb-3" data-id="element-438" data-mp="7nd2gjnx2isp">
                    {company.name}
                  </h3>
                  <p className="text-gray-600 text-sm leading-relaxed font-light mb-4" data-id="element-439" data-mp="3bavle2azckkd">
                    {company.description}
                  </p>
                  <div className="flex items-center text-sm text-gray-500 group-hover:text-red-600 transition-colors" data-id="element-440" data-mp="33q1hukk2n4xz">
                    <span data-id="element-441" data-mp="2yt173wca1e0j">Learn more</span>
                    <svg className="w-4 h-4 ml-2 group-hover:translate-x-1 transition-transform" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-442" data-mp="2tsnbxevrxyjx">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" data-id="element-443" data-mp="2kul2qc1vzzlk" />
                    </svg>
                  </div>
                </div>
              </a>)}
          </div>
        </div>
      </section>
    </div>;
};